import { render, staticRenderFns } from "./WalletSuscription.vue?vue&type=template&id=05818883&"
import script from "./WalletSuscription.vue?vue&type=script&lang=js&"
export * from "./WalletSuscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports